import { useAuth } from '@clerk/nextjs';
import { useQuery } from '@tanstack/react-query';
import { Query } from '@web/constants/query';
import * as App from '@web/contracts/App';
import axios from 'axios';

export interface ApiResponse {
  success: true;
  country?: string;
  products: Record<string, App.ActivePlan>;
}

/**
 * React Query hook to fetch all the available products from stripe
 * @returns ApiResponse | undefined
 */
const useProducts = () => {
  const { isSignedIn, orgId } = useAuth();

  return useQuery({
    queryKey: [Query.StripeKeys.products],
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !!isSignedIn && !!orgId,
    staleTime: Infinity,
    queryFn: async () => {
      const response = await axios.get<ApiResponse>(`${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/products`);
      return response.data;
    },
  });
};

export { useProducts };
